import { reactive } from 'vue';

export const criarManutExecucao = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idequipamento: 0,
        idservico: 0,
        dtexecucao: '',
        kmhoras: 0,
        kmhoras_tipo: '',
        obs: '',
        ckavulsa: 'S',
        idlogin: 0
    });
}